import axios from "axios";
import { renewToken } from "./auth";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";
import { LaunchError } from "../utils/errors";

const CREATE_AUTOMATION_API_KEY_FUNCTION = "createAutomationApiKey";

export const startCreateMcpApiKey = () => async (dispatch, getState) => {
  try {
    const token = await dispatch(renewToken());
    const advertiserID = getState()?.auth?.user?.advertiserID;

    const { data } = await axios({
      method: "post",
      url: `${getCloudFunctionUrl(CREATE_AUTOMATION_API_KEY_FUNCTION)}/${CREATE_AUTOMATION_API_KEY_FUNCTION}`,
      data: advertiserID ? { advertiserID } : {},
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!data?.ok || !data?.data?.plaintextKey) {
      return { ok: false };
    }

    return { ok: true, apiKey: data.data.plaintextKey };
  } catch (error) {
    dispatch(
      LaunchError(error, false, [], {
        functionName: "startCreateMcpApiKey",
      })
    );
    return { ok: false };
  }
};
